import React, { FC, memo, ReactNode } from 'react'
import s from './AfishaTag.module.sass'
import { Button } from '@shared/ui/Actions/Button'

import IconChevron from '@icons/icon-chevron-medium.svg'
import { ErrorBoundary } from '../../../../../lib/components/ErrorBoundary'

interface Props {
  onClick: () => void
  className?: string
  active?: boolean
  children?: ReactNode
  to?: string
}

const AfishaTag: FC<Props & React.ButtonHTMLAttributes<any>> = ({
  onClick,
  className = '',
  active = false,
  children,
  to,
  ...props
}) => {
  return (
    <ErrorBoundary>
      {to ? (
        <Button.Link
          href={to}
          sizes='M'
          mode='white-border'
          className={`${s.button} ${className}`}
          onClick={onClick}
          data-active={active}
          {...props}>
          {children}
        </Button.Link>
      ) : (
        <Button
          sizes='M'
          mode='white-border'
          className={`${s.button} ${className}`}
          onClick={onClick}
          data-active={active}
          {...props}>
          <IconChevron className={s.icon} />
          {children || 'Выбор Афиши'}
        </Button>
      )}
    </ErrorBoundary>
  )
}

export default memo(AfishaTag)
